var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import gs from '../../styles/style';
var useModal = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.isOpen, isOpen = _c === void 0 ? false : _c, onClose = _b.onClose;
    var _d = useState({
        isOpen: isOpen
    }), state = _d[0], setState = _d[1];
    var open = function (props) {
        document.body.classList.add(gs('modal-open'));
        setState({
            isOpen: true,
            props: props
        });
    };
    var close = function (props) {
        document.body.classList.remove(gs('modal-open'));
        setState({
            isOpen: false,
            props: props
        });
        if (onClose) {
            onClose(props);
        }
    };
    return __assign({ open: open, close: close }, state);
};
var ModalContext = React.createContext({});
var Modal = function (_a) {
    var modal = _a.modal, children = _a.children;
    if (!modal.isOpen) {
        return null;
    }
    return (React.createElement(ModalContext.Provider, { value: modal },
        React.createElement("div", { className: gs('modal-backdrop', 'fade', 'show') }),
        React.createElement("div", { className: gs('modal', 'fade', 'show'), tabIndex: -1, role: "dialog", onClick: function () { return modal.close(); } },
            React.createElement("div", { className: gs('modal-dialog'), role: "document" },
                React.createElement("div", { className: gs('modal-content'), onClick: function (event) { return event.stopPropagation(); } }, children)))));
};
var ModalHeader = function (_a) {
    var children = _a.children;
    var modal = useContext(ModalContext);
    return (React.createElement("div", { className: gs('modal-header') },
        children,
        React.createElement("button", { type: "button", className: gs('close'), onClick: function () { return modal.close(); } },
            React.createElement("span", { "aria-hidden": "true" }, "\u00D7"))));
};
var ModalBody = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: gs('modal-body') }, children));
};
var ModalFooter = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: gs('modal-footer') }, children));
};
var ConfirmationModal = function (_a) {
    var modal = _a.modal, children = _a.children;
    var t = useTranslation()[0];
    var confirmValue = typeof modal.props != 'undefined' ? modal.props : true;
    return (React.createElement(Modal, { modal: modal },
        React.createElement(ModalBody, null, children),
        React.createElement(ModalFooter, null,
            React.createElement("button", { type: "button", className: gs('btn', 'btn-default'), onClick: function () { return modal.close(); } }, t('cancel')),
            ' ',
            React.createElement("button", { type: "button", className: gs('btn', 'btn-secondary'), onClick: function () { return modal.close(confirmValue); } }, t('confirm')))));
};
var InformationalModal = function (_a) {
    var modal = _a.modal, children = _a.children;
    var t = useTranslation()[0];
    return (React.createElement(Modal, { modal: modal },
        React.createElement(ModalBody, null, children),
        React.createElement(ModalFooter, null,
            React.createElement("button", { type: "button", className: gs('btn', 'btn-secondary'), onClick: function () { return modal.close(modal.props); } }, t('continue')))));
};
export { Modal, ModalHeader, ModalBody, ModalFooter, ConfirmationModal, InformationalModal, useModal };
